/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q }) {
    return axios.get(this.url, { params: { q } });
  }

  contacts({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/contacts`, {
      params: { q, page, since, until },
    });
  }

  conversations({ q, page = 1, since, until, includeMessageContent = false }) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        q,
        page,
        since,
        until,
        ...(includeMessageContent && { include_message_content: true }),
      },
    });
  }

  messages({ q, page = 1, since, until, from, inboxId }) {
    return axios.get(`${this.url}/messages`, {
      params: { q, page, since, until, from, inbox_id: inboxId },
    });
  }

  articles({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/articles`, {
      params: { q, page, since, until },
    });
  }
}

export default new SearchAPI();
